import React, { useEffect, useState } from 'react';
import { masterColors } from '../../../helpers/DropdownValues/colorService';
import { colorFields } from '../../../helpers/InputFields/InputFields';
import { createColorAction, deleteColorAction, fetchColorAction } from '../../../utils/redux/color/colorActions';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import DynamicFormModal from '../../Modal/DynamicFormModal/DynamicFormModal';

const ColorListingPage = () => {
    const dispatch = useDispatch();
    const { colors, isLoading } = useSelector(state => state.color);
    const [show, setShow] = useState(false);

    useEffect(() => {
        dispatch(fetchColorAction());
    }, [dispatch]);

    const handleDelete = (id) => {
        dispatch(deleteColorAction(id));
    };
    const [modalConfig, setModalConfig] = useState({
        show: false,
        title: "",
        fields: [],
        initialData: {},
        dropdownData: {},
        onSubmit: null
    });

    const openAddColorModal = () => {
        setModalConfig({
            show: true,
            title: "Add Color",
            fields: colorFields,
            initialData: {},
            dropdownData: { masterColors: masterColors },
            onSubmit: async (data) => {
                await dispatch(createColorAction(data));
            }
        });
    };

    return (
        <>
            <div className="d-flex flex-column align-items-center">
                <div className="d-flex my-4 w-100 justify-content-between">
                    <h3>Collection Partners</h3>
                    <button onClick={openAddColorModal} className="btn btn-primary">
                        + Add Partner
                    </button>
                </div>

                <div className="w-100">
                    <table className="table table-sm align-middle mt-3">
                        <thead className="table-secondary">
                            <tr>
                                <th className="p-3">Color Name</th>
                                <th className="p-3">Color Code</th>
                                <th className="p-3">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {colors?.length ? (
                                colors?.map(item => (
                                    <tr key={item._id}>
                                        <td>{item.name}</td>
                                        <td className='d-flex flex-row'>
                                            <div style={{ height: "30px", width: "30px", borderRadius: "100%", backgroundColor: `#${item.code}` }}></div>&nbsp;
                                            <span>#{item?.code}</span>
                                        </td>
                                        <td>
                                            <button
                                                className="btn btn-sm text-danger"
                                                onClick={() => handleDelete(item._id)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center text-muted">
                                        {/* {isLoading ? "Loading..." : "No partners found"} */}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <DynamicFormModal
                show={modalConfig.show}
                title={modalConfig.title}
                fields={modalConfig.fields}
                initialData={modalConfig.initialData}
                onSubmit={modalConfig.onSubmit}
                dropdownData={modalConfig.dropdownData}
                onHide={() =>
                    setModalConfig(prev => ({ ...prev, show: false }))
                }
            />
        </>
    )
};

export default ColorListingPage;